import React from "react";
import { Table, } from "antd";
import { rateSetModel } from "../rateSetModel";
import { ColumnsType } from "antd/es/table";
import { IMdUserDetail, IRateItem } from "../rateSetTypes";
import moment from "moment";
import { YhBut } from "@src/components/YhButton";
import { EditModeType } from "@src/types/FmsTypes";


export function DataTable() {
    const {
        dataSource,
        pgCfg,
        loadData,
        setDrawerVisible,
        setSelectedRow,
        setEditType
    } = rateSetModel();
    const onDetail = (type: EditModeType, data: IMdUserDetail) => {
        setDrawerVisible(true)
        setSelectedRow(data)
        setEditType(type)
    }

    const columns: ColumnsType<IMdUserDetail> = [
        {
            align: 'center',
            title: '序号',
            width: 60,
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            title: '编码',
            width: 150,
            dataIndex: 'code',
        },
        {
            align: "center",
            title: '模版名称',
            width: 150,
            dataIndex: 'name',
        },
        {
            align: "center",
            title: '系统名称',
            width: 150,
            dataIndex: 'appName',
        },
        {
            align: "left",
            title: '评价类型',
            width: 150,
            dataIndex: 'indicatorList',
            render: (v) => {
                return (v.map((i: IRateItem) => (<><span style={{ lineHeight: '28px' }}>{i.name}</span><br /></>)))
            }
        },
        {
            align: "center",
            title: '创建人',
            width: 120,
            dataIndex: 'createUser',
        },
        {
            align: "center",
            title: '创建时间',
            width: 200,
            dataIndex: 'createTime',
            render: (dateArray) => dateArray ? moment([
                dateArray[0],
                dateArray[1] - 1, // 将月份减1，使5→4（代表5月）
                dateArray[2],
                dateArray[3],
                dateArray[4],
                dateArray[5]
            ]).format("YYYY-MM-DD HH:mm:ss") : ''
        },
        {
            align: "center",
            title: '操作',
            width: 120,
            dataIndex: 'enable',
            fixed: "right",
            render: (value, record, index) => {
                return (
                    <>
                        <YhBut
                            typeName="icon-bianji1"
                            text="编辑"
                            style={{ color: "#028E19", fontSize: "18px" }}
                            click={() => onDetail('edit', record)}
                        />

                    </>
                )
            }
        },
    ];


    return (
        <Table
            style={{ cursor: "pointer" }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
